import { z } from 'zod';

export const ProdutoCategoriaSchema = z.object({
    prc_caminho: z.string().nullable(),
    prc_descricao: z.string(),
    prc_idpk: z.number(),
    prc_imagem: z.string().nullable(),
    prc_sequencia: z.string().nullable(),
});

export type ProdutoCategoria = z.infer<typeof ProdutoCategoriaSchema>;
